export enum AI_ASSISTANT_PERMISSIONS {
  AI_ASSISTANT = 'INTEGRATION_AIASSISTANT',
  AI_ASSISTANT_CONFIG = 'INTEGRATION_AIASSISTANTCONFIG',
}
